import React from 'react'

const ArrowIcon: React.FC = () => {
  return (
    <svg
      preserveAspectRatio="none"
      data-bbox="20 47.389 160 105.222"
      viewBox="20 47.389 160 105.222"
      height="16"
      width="19"
      xmlns="http://www.w3.org/2000/svg"
      data-type="shape"
      role="presentation"
      aria-hidden="true"
      aria-label=""
      fill="#3C60A5"
    >
      <g>
        <path d="M64.522 47.389H20L66.376 100 20 152.611h44.522L110.899 100 64.522 47.389z"></path>
        <path d="M133.622 47.389h-44.52L135.479 100l-46.377 52.611h44.52L180 100l-46.378-52.611z"></path>
      </g>
    </svg>
  )
}

export default ArrowIcon